module.exports = "/images/lines-3.jpg";